import { ChildrenRef } from '../../../../../lib/web/components/children-ref';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { Input } from '../../../../../lib/web/components/input';
import { ApiService } from '../../../services/api.service';
import { SessionService } from '../../../services/session.service';

export interface DiscoveryAssistantStep {
    enter(assistant: any, interestClusters: any[], mode: string): void;
    exit(): void;
}

@Component({
    selector: '.p-discovery-asistant'
})
export class DiscoveryAssistantComponent extends ComponentBase<HTMLElement> {

    @Input('assistant', { isJSON: true })
    public _assistant: any = null;
    @Input('interestClusters', { isJSON: true })
    public _interestClusters: any[] = null;
    @Input('mode')
    private _mode: string = null;

    @ChildrenRef(HTMLDivElement, '.p-discovery-asistant__step')
    public _steps: HTMLDivElement[] = [];

    public constructor(node: HTMLElement, private _sessionService: SessionService, private _apiService: ApiService) {
        super(node);   
        
        this.addWindowEventListener('discovery-assistant-next-step', () => this.setStep('next'));
        this.addWindowEventListener('discovery-assistant-previous-step', () => this.setStep('previous'));
        this.addWindowEventListener('discovery-assistant-reset', () => this.setStep(this._mode === 'web' ? 1 : 0));
    }

    public onInit(): void {
        super.onInit();
        if (this._mode !== 'web' && this._sessionService.isSigned) {
            this.onSignOutUser();
        }   
        else {    
            this.setStep(this._mode === 'web' ? 1 : 0);
        }        
    }

    private async onSignOutUser(): Promise<void> {
        if (this._mode !== 'web') {
            await this._apiService.delete('/api/v1/user/sign-in');
            this._sessionService.remove();
            window.location.reload();
        }
    }

    private setStep(direction: 'next' | 'previous' | number): void {
        const currentStep: number = typeof direction === 'number' ? direction - 1: this.currentStep;
        direction = typeof direction === 'number' ? 'next': direction;
        this._steps.forEach((step, index) => {
            const stepComponent = (step.childNodes[0].componentRef.ref as any as DiscoveryAssistantStep);
            if (index === currentStep) {
                stepComponent.exit();
            }
            if (index !== currentStep + 1 && direction === 'next') {
                step.classList.add('u-hidden');
            }
            else if (index !== currentStep - 1 && direction === 'previous') {
                step.classList.add('u-hidden');
            }
            else {
                step.classList.remove('u-hidden');
                stepComponent.enter(this._assistant, this._interestClusters, this._mode);
            }
        });   
        window.scrollTo({ top: 0, behavior: 'smooth' }); 
    }

    private get currentStep(): number {
        const index: number = this._steps.findIndex((step) => !step.classList.contains('u-hidden'));
        return index >= 0 ? index : -1;
    }
}
